import _ from 'lodash';
import Entity from './Entity';

const fieldsWithDynamicAllowedValues = {
  type: { enumName: 'TransactionTypeEnum' },
  payment_type: { enumName: 'PaymentTypeEnum' }
};

const invoiceTypes = {
  CARRYOVER_INVOICE: 'Carryover Invoice',
  MANUAL_INVOICE: 'Manual Invoice',
  FIRST_MONTH_INVOICE: 'First Month Invoice',
  AUTO_INVOICE: 'Auto Invoice',
  VALIDATION_INVOICE: 'Validation Invoice'
};

const lineItemEntryTypes = {
  CHARGE: 'Charge',
  PAYMENT: 'Payment',
  LANDLORD_COLLECTED: 'Landlord Collected',
  ADJUSTMENT: 'Adjustment',
  WRITE_OFF: 'Write Off',
  REVERSAL: 'Reversal',
  REFUND: 'Refund'
};

const creditEntryTypes = {
  CREATION: 'Creation',
  OVERPAYMENT: 'Overpayment',
  REVERSAL: 'Reversal',
  RESTORATION: 'Restoration',
};
export default class Transaction {
  fields = {
    id: {
      value: null
    },
    invoice_number: {
      value: null
    },
    type: {
      value: null
    },
    payment_type: {
      value: null
    },
    payment_id: {
      value: null
    },
    amount: {
      value: null
    },
    notes: {
      value: null
    },
    invoice_id: {
      value: null
    },
    line_item_entry_id: {
      value: null
    },
    credit_entry_id: {
      value: null
    },
    created_at: {
      value: null
    },
    updated_at: {
      value: null
    },
    application_date: {
      value: null
    }
  };
  
  static createFromQueryValues(values) {
    const transaction = new this();
    
    for (let field in transaction.fields) {
      if (values.hasOwnProperty(field)) {
        switch (field) {
          case 'updated_at':
          case 'created_at':
            transaction.fields[field].value = (values[field] === null) ?
            values[field] :
            new Date(Number(values[field]));
            break;
          default:
            transaction.fields[field].value = values[field];
        }
      }
    }
    
    return transaction;
  }

  getQueryFieldValues() {
    const values = _.cloneDeep(TransactionInput);

    for (let field in values) {
      values[field] = this.fields[field].value;
    }

    return values;
  }

  static async getFieldAllowedValues(fields) {
    return await Entity.getFieldAllowedValues(
      {},
      fieldsWithDynamicAllowedValues,
      fields
    );
  }

  static getTypeEnum() {
    return {
      ...invoiceTypes,
      ...lineItemEntryTypes,
      ...creditEntryTypes
    };
  }

  /**
   * Charges and reversals/restorations should not appear in the subscription and invoice history tables/reports
   */
  static getTypeEnumForHistoryReports() {
    const types  = Transaction.getTypeEnum();
    delete types.CHARGE;
    delete types.REVERSAL;
    delete types.RESTORATION;

    return types;
  }  

  update(transactionData) {
    this.fields.notes.value = transactionData.notes;
  }
}

export const TransactionInput = {
  id: null,
  invoice_number: null,
  type: null,
  payment_type: null,
  payment_id: null,
  amount: null,
  notes: null,
  invoice_id: null,
  line_item_entry_id: null,
  credit_entry_id: null
}